import qs from 'qs';
import iView from 'iview';
import axios from 'axios';
import CryptoJS from './crypto';
import { Message } from 'element-ui';

let isErrorMsg = false

axios.defaults

export default function(config) {
    let sid = localStorage.getItem('token')
    console.log(process.env.NODE_ENV)
    if (process.env.NODE_ENV !== 'development' && location.href.indexOf('http://aibeings.yf-gz.cn') < 0) {
        config.url = '/digitalHuman' + config.url
    }

    // if(!config.isMock) {
    //     config.url = '/zzcbpm' + config.url
    // }
    if (config.params) {
        config.params.sid = sid
    } else {
        config.params = {
            sid
        }
    }
    if (config.isFormData) {
        if (!config.isFile) {
            config.data = qs.stringify(config.data);
        }
        !config.headers && (config.headers = {});
        if(!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
    }

    if (config.isAddHeader) {
        console.log(axios.defaults)
        config.headerList.map(item => {
            // config.headers[item.headerKey] = item.headerKeyValue
            // config.headers.projectName = 'investmentTea'
            axios.defaults.headers.common[item.headerKey] = item.headerKeyValue
        })
    }

    return axios(config).then(
        res => {

            if (res.data && typeof(res.data) === 'string') {
                res.data = JSON.parse(CryptoJS.Decrypt(res.data))
            }

            if (res.data.status >= 1 && res.data.status !== 401) {
                config.showSuccess &&
                Message.success({
                    message: res.data.msg,
                    showClose: true
                });
                return Promise.resolve(res);
            }
            console.log(res)
            if (res.data.status === 0) {
                !config.hiddenError &&
                Message.error({
                    message: res.data.msg,
                    showClose: true
                });
                return Promise.reject(res);
            }

            if (res.data.status === 401) {
                Message.error({
                    message: '您没有这个权限！',
                    showClose: true
                });
            }

            if (res.data.status < 0) {
                console.log(config)
                if(!isErrorMsg && config.url !== '/api/wx/employee/currentEmployee') {
                    !config.hiddenError &&
                    Message.error({
                        message: res.data.msg,
                        showClose: true
                    });
                    isErrorMsg = true
                    setTimeout(() => {
                        isErrorMsg = false
                    },1500)
                }
                localStorage.removeItem('user');
                localStorage.removeItem('currentUser');
                location.href = `#/login`;
                return Promise.reject(res);
            }
            return Promise.resolve(res);
        }
    );
}



// WEBPACK FOOTER //
// ./src/digitalHuman/tool/axios.js